"use client";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Image from "next/image";

import { Plans } from "../../../components/Plans";
import ProtectedArticle from "../../../components/ProtectedArticle";
import readingIllustration from "../../../public/images/undraw_reading.svg";
import type { PublisherData } from "../../../types/Publisher";
import { useAuthContext } from "../../../utils/auth/useAuth";

export default function PageInner({
  articleId,
  publisherData,
}: {
  articleId: string;
  publisherData: PublisherData | null;
}) {
  const { user, userAdditionalData } = useAuthContext();

  const protectedContentMessage = (
    <Box sx={{ textAlign: "center" }}>
      <Typography variant="h2" gutterBottom>
        Assine já e tenha acesso a este artigo e muito mais!
      </Typography>

      <Plans />

      <Box sx={{ marginTop: 2 }}>
        <Image height={300} src={readingIllustration} alt="conteúdo disponível apenas para assinantes" />
      </Box>
    </Box>
  );

  if (!user || !userAdditionalData?.activeSubscription) {
    return protectedContentMessage;
  }

  return <ProtectedArticle id={articleId} publisherData={publisherData} />;
}
